import React from 'react';
import ColumnHeader from '../../../../ColumnHeader';

import styles from './highSchoolStandings.scss';

const Header = (props) => {
    const {
        gridLayout,
        showBoysP6,
        showGirlsP6,
    } = props;

    const columnStyle = 'w-100 text-center';

    return (
        <div className={`${styles.headers} d-grid w-100`} style={{ gridTemplateColumns: gridLayout.join(' ') }}>
            <ColumnHeader columnName="Rank" />
            <ColumnHeader />
            <ColumnHeader columnName="Team Name" />
            <ColumnHeader columnName={<div className={columnStyle}>League<br />Record</div>} />
            <ColumnHeader columnName={<div className={columnStyle}>Overall<br />Record</div>} />
            {showBoysP6 && (
                <ColumnHeader columnName={<div className={columnStyle}>Boys<br />P6</div>} />
            )}
            {showGirlsP6 && (
                <ColumnHeader columnName={<div className={columnStyle}>Girls<br />P6</div>} />
            )}
        </div>
    );
};

export default Header;
